module.exports = __webpack_public_path__ + "img/chargingpoint-realized-private.cd28e876.png";